// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Garderobo Smart Search Widget — Base Styles
   Minimalist monochrome design (nuw.store inspired)
   ============================================ */

:root {
  /* Colors — monochrome palette */
  --grb-color-primary: #000000;
  --grb-color-primary-hover: #333333;
  --grb-color-text: #000000;
  --grb-color-text-secondary: #767676;
  --grb-color-border: #e0e0e0;
  --grb-color-border-light: #f0f0f0;
  --grb-color-background: #ffffff;
  --grb-color-background-secondary: #f5f5f5;
  --grb-color-overlay: rgba(0, 0, 0, 0.4);
  --grb-color-error: #d32f2f;
  --grb-color-sale: #d32f2f;

  /* Typography */
  --grb-font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  --grb-font-size-xs: 11px;
  --grb-font-size-sm: 12px;
  --grb-font-size-base: 13px;
  --grb-font-size-lg: 14px;
  --grb-font-size-xl: 16px;

  /* Sizes */
  --grb-border-radius: 0px;
  --grb-card-border-radius: 0px;
  --grb-spacing-xs: 4px;
  --grb-spacing-sm: 8px;
  --grb-spacing-md: 16px;
  --grb-spacing-lg: 24px;
  --grb-spacing-xl: 32px;

  /* Grid */
  --grb-grid-columns-desktop: 4;
  --grb-grid-columns-tablet: 3;
  --grb-grid-columns-mobile: 2;
  --grb-grid-gap: 2px;

  /* Sidebar */
  --grb-sidebar-width: 260px;

  /* Z-index */
  --grb-z-index: 9999;
}

/* Minimal reset scoped to widget */
.grb-widget,
.grb-widget *,
.grb-widget *::before,
.grb-widget *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.grb-widget {
  font-family: var(--grb-font-family), sans-serif;
  font-size: var(--grb-font-size-base);
  color: var(--grb-color-text);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.grb-widget button {
  font-family: inherit;
  font-size: inherit;
  cursor: pointer;
  border: none;
  background: none;
  color: inherit;
}

.grb-widget input {
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  outline: none;
}

.grb-widget input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid var(--grb-color-border);
  background: var(--grb-color-background);
  cursor: pointer;
  flex-shrink: 0;
  position: relative;
}

.grb-widget input[type="checkbox"]:checked {
  background: var(--grb-color-primary);
  border-color: var(--grb-color-primary);
}

.grb-widget input[type="checkbox"]:checked::after {
  content: '';
  position: absolute;
  left: 4px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 1.5px 1.5px 0;
  transform: rotate(45deg);
}

.grb-widget img {
  display: block;
  max-width: 100%;
}

/* Accent button — filled background, reusable */
.grb-widget .grb-widget--btn-accent {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  padding: 0 var(--grb-spacing-lg);
  background: var(--grb-color-primary);
  color: #fff;
  font-size: var(--grb-font-size-sm);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.grb-widget .grb-widget--btn-accent:hover {
  background: var(--grb-color-primary-hover);
}

.grb-widget .grb-widget--btn-accent:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/styles/base.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,kCAAkC;EAClC,yBAAyB;EACzB,mCAAmC;EACnC,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,yCAAyC;EACzC,uCAAuC;EACvC,0BAA0B;EAC1B,yBAAyB;;EAEzB,eAAe;EACf,sGAAsG;EACtG,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;;EAExB,UAAU;EACV,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,SAAS;EACT,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,mBAAmB;;EAEnB,YAAY;EACZ,0BAA0B;;EAE1B,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;;;;EAIE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,uCAAuC;EACvC,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,oCAAoC;EACpC,WAAW;EACX,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* ============================================\n   Garderobo Smart Search Widget — Base Styles\n   Minimalist monochrome design (nuw.store inspired)\n   ============================================ */\n\n:root {\n  /* Colors — monochrome palette */\n  --grb-color-primary: #000000;\n  --grb-color-primary-hover: #333333;\n  --grb-color-text: #000000;\n  --grb-color-text-secondary: #767676;\n  --grb-color-border: #e0e0e0;\n  --grb-color-border-light: #f0f0f0;\n  --grb-color-background: #ffffff;\n  --grb-color-background-secondary: #f5f5f5;\n  --grb-color-overlay: rgba(0, 0, 0, 0.4);\n  --grb-color-error: #d32f2f;\n  --grb-color-sale: #d32f2f;\n\n  /* Typography */\n  --grb-font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n  --grb-font-size-xs: 11px;\n  --grb-font-size-sm: 12px;\n  --grb-font-size-base: 13px;\n  --grb-font-size-lg: 14px;\n  --grb-font-size-xl: 16px;\n\n  /* Sizes */\n  --grb-border-radius: 0px;\n  --grb-card-border-radius: 0px;\n  --grb-spacing-xs: 4px;\n  --grb-spacing-sm: 8px;\n  --grb-spacing-md: 16px;\n  --grb-spacing-lg: 24px;\n  --grb-spacing-xl: 32px;\n\n  /* Grid */\n  --grb-grid-columns-desktop: 4;\n  --grb-grid-columns-tablet: 3;\n  --grb-grid-columns-mobile: 2;\n  --grb-grid-gap: 2px;\n\n  /* Sidebar */\n  --grb-sidebar-width: 260px;\n\n  /* Z-index */\n  --grb-z-index: 9999;\n}\n\n/* Minimal reset scoped to widget */\n.grb-widget,\n.grb-widget *,\n.grb-widget *::before,\n.grb-widget *::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n.grb-widget {\n  font-family: var(--grb-font-family), sans-serif;\n  font-size: var(--grb-font-size-base);\n  color: var(--grb-color-text);\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.grb-widget button {\n  font-family: inherit;\n  font-size: inherit;\n  cursor: pointer;\n  border: none;\n  background: none;\n  color: inherit;\n}\n\n.grb-widget input {\n  font-family: inherit;\n  font-size: inherit;\n  color: inherit;\n  outline: none;\n}\n\n.grb-widget input[type=\"checkbox\"] {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  border: 1px solid var(--grb-color-border);\n  background: var(--grb-color-background);\n  cursor: pointer;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.grb-widget input[type=\"checkbox\"]:checked {\n  background: var(--grb-color-primary);\n  border-color: var(--grb-color-primary);\n}\n\n.grb-widget input[type=\"checkbox\"]:checked::after {\n  content: '';\n  position: absolute;\n  left: 4px;\n  top: 1px;\n  width: 5px;\n  height: 9px;\n  border: solid #fff;\n  border-width: 0 1.5px 1.5px 0;\n  transform: rotate(45deg);\n}\n\n.grb-widget img {\n  display: block;\n  max-width: 100%;\n}\n\n/* Accent button — filled background, reusable */\n.grb-widget .grb-widget--btn-accent {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 42px;\n  padding: 0 var(--grb-spacing-lg);\n  background: var(--grb-color-primary);\n  color: #fff;\n  font-size: var(--grb-font-size-sm);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.grb-widget .grb-widget--btn-accent:hover {\n  background: var(--grb-color-primary-hover);\n}\n\n.grb-widget .grb-widget--btn-accent:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
